import { orderBy } from 'lodash';

import { PLACE_ACTION_TYPE_LABELS } from './PlaceActionsTable.constants';

export function formatPlaceActionType(type) {
  return PLACE_ACTION_TYPE_LABELS[type] || type;
}

export function sortPlaceActions(providerEntityAttributes) {
  return orderBy(
    providerEntityAttributes,
    ['attributes.placeActionType', 'attributes.uri'],
    ['asc', 'asc'],
  );
}
